<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-content__meta d-flex f-between">
        <h1 class="page-title">Новости</h1>
        <div class="page-breadcrumb">
          <BreadCrumb />
        </div>
      </div>

      <div class="news-wrapper">
        <div class="flex-container f-between f-wrap">
          <router-link to="#" v-for="item in news" :keys="item.id"
            class="news-item-container d-block text-white flex-half">
            <div class="news-title">
              <p>
                {{ item.title }}
              </p>
            </div>
            <div class="news-item-meta">
              <span class="news-type">статьи</span>
              <i class="news-date">{{ item.date }}.</i>
            </div>
            <div class="news-item-img ratio2by1 p-relative hidden">
              <img :src="item.img" alt="News Img" class="d-block p-absolute w-100 h-100 transition" />
            </div>

            <div class="news-anchor">
              <pre>{{ item.desc }}</pre>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../components/BreadCrumb";
import { mapGetters } from "vuex";

export default {
  components: {
    BreadCrumb
  },
  computed: {
    ...mapGetters({ news: 'news/posts' })
  }
};
</script>

<style lang="scss" scoped>
.news-item-img {
  img {
    object-fit: contain;
    width: 100%;
  }
}

pre {
  white-space: pre-line;
  line-height: 160%;
  margin-bottom: 48px;
  font-size: 18px;
  font-family: var(--medium);
}

.news-anchor {
  line-height: 140%;
  margin-bottom: 48px;
}
</style>
